export default __webpack_public_path__ + "0309e0f94a30f8c71f433ed496fd0516.png";